(function (global) {
  'use strict';
  if (global.TabletopAudio) return;

  const doc = global.document;
  if (doc && !doc.querySelector('link[href$="tabletop-audio.css"]')) {
    const stylesheet = doc.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = '/tabletop-audio.css';
    doc.head.append(stylesheet);
  }
  const controls = new Map();
  const mediaLevels = new WeakMap();
  const mediaRoles = new WeakMap();
  const watchedMedia = new WeakSet();
  const trackedMedia = new Set();
  const contextGains = new Map();
  const mediaProto = global.HTMLMediaElement && global.HTMLMediaElement.prototype;
  const volumeProperty = mediaProto && Object.getOwnPropertyDescriptor(mediaProto, 'volume');
  const nodeProto = global.AudioNode && global.AudioNode.prototype;
  const originalConnect = nodeProto && nodeProto.connect;
  const originalDisconnect = nodeProto && nodeProto.disconnect;
  let active = null;
  let drag = null;
  let refreshQueued = false;

  const legacy = {
    'alice-garden': { hide: 'header .header-audio,#audioDialog' },
    'co-mix': { hide: 'header #music,header #volumeLabel,header #effects' },
    'dino-racer': { hide: '#app>header [data-do="music"],#app>header [data-do="sfx"],#app>header .volume-control' },
    'familienbande': { hide: 'header #musicButton,header label:has(#volume),header #effectsButton' },
    'fifty': { hide: 'header #audio,#sounds' },
    'got-five': { hide: 'header #sound,header #music,header label:has(#volume)' },
    'hooky': { hide: '.setting-row:has([data-action="effects"]),.setting-row:has(#effects-volume),.setting-row:has([data-action="music"]),.setting-row:has(#music-volume)', settings: '#settings' },
    'imagician': { hide: '#top #musicButton,#top .top-volume,#top #effectsButton,#settings label:has(#musicVolume),#settings label:has(#fxVolume),#settings [data-action="music"]' },
    'jinxo': { hide: 'header .top-music,#soundDialog label:has(#effects),#soundDialog label:has(#music),#soundDialog label:has(#volume)', settings: '#soundBtn' },
    'kalypso': { hide: 'header #musicButton,header .top-volume,header #effectsButton,#audioDialog label:has(#musicOn),#audioDialog label:has(#musicVolume),#audioDialog label:has(#effectsOn),#audioDialog label:has(#effectsVolume)' },
    'krazy-wordz': { hide: '.sidebar-tools #sound' },
    'last-message': { hide: '#settings label:has(#music-volume),#settings label:has(#effects-volume),#settings .settings-grid>small', settings: '#settings-open' },
    'map-masters': { hide: '.settings-form label:has(#effectsVolume),.settings-form label:has(#musicVolume),.settings-form label:has(#muteAudio),#testAudio', settings: '#settings' },
    'mask-of-anubis': { hide: 'header #musicMenu,#settingsDialog label:has(#music),#settingsDialog label:has(#effects)', settings: '#settings' },
    'micromacro': { hide: 'header #soundButton,#sound' },
    'one-round': { hide: '#dialog label:has(#effects),#dialog label:has(#music),#dialog [data-action="mute"]', settings: '#settings' },
    'petiquette': { hide: 'header #audio,header #music,header .music-volume' },
    'pyradice': { hide: 'label:has(#music-slider),label:has(#effects-slider)', settings: '#topbar [data-action="settings"]' },
    'second-chance': { hide: 'header #music,header label:has(#volume),header #effects' },
    'staccs': { hide: 'label:has(#musicRange),label:has(#musicOn),label:has(#effectsRange),#dialog p:has(+ #fullscreen)', settings: '#settingsButton' },
    'super-snipers': { hide: 'label:has(#music-volume),label:has(#effects-volume)', settings: '.topbar [data-action="settings"]' },
    'tenby-game': { hide: '.settings-list label:has(#music-toggle),.settings-list label:has(#volume),.settings-list label:has(#effects-toggle)', settings: 'header [data-command="settings"]' },
    'too-many-cinderellas': { hide: 'header #musicToggle,header .header-volume,#sound label:has(#music),#sound label:has(#effects)', settings: '#settings' },
    'twofold': { hide: '#preferences #musictoggle,#preferences #volume,#preferences #volumevalue,#preferences #effectstoggle' },
    'waypoints': { hide: '#audioDialog #musicToggle,#audioDialog label:has(#musicVolume),#audioDialog label:has(#effectsVolume)', settings: '#audioButton' },
    '5-minute-dungeon': { hide: '#dialog .setting-row:has(#music-volume),#dialog .setting-row:has(#effects-volume)', settings: 'header [data-action="settings"]' },
    'cozy-stickerville': { hide: '#settings .volume-row:has([data-volume="music"]),#settings .volume-row:has([data-volume="effects"])', settings: '[data-do="settings"]' },
    'dice-pool-party': { hide: '#dialog .setting-row:has([for="music-volume"]),#dialog .setting-row:has([for="effects-volume"]),#dialog #music-volume,#dialog #effects-volume', settings: '#navigation [data-action="settings"]' },
    'giro-galoppo': { hide: '.setting-row:has(#music-volume),.setting-row:has(#effects-volume)', settings: '#settings' },
    'karuba': { hide: '.audio-control:has(#music),.audio-control:has(#effects)', settings: 'header [data-action="settings"]' },
    'pop-art': { hide: '#dialog .volume-control:has(#effects),#dialog .volume-control:has(#music),#mute-audio', settings: '#settings' },
    'search-for-planet-x': { hide: '#dialog .setting:has(#music-volume),#dialog .setting:has(#effects-volume)', settings: 'header.bar [data-do="settings"]' },
    'whirling-witchcraft': { hide: '#dialog .setting:has(#music-volume),#dialog .setting:has(#effects-volume)', settings: '#topbar [data-action="settings"]' },
    'whoowasit': { hide: 'header .header-audio,#modal label[for="music-volume"],#modal #music-volume,#modal label:has(#music-mute),#modal label[for="effects-volume"],#modal #effects-volume,#modal label:has(#effects-mute)', settings: '#settings-open' },
    'rushout': { hide: '#dialog label[for="music-volume"],#dialog #music-volume,#dialog [data-action="muteMusic"],#dialog label[for="effects-volume"],#dialog #effects-volume,#dialog [data-action="muteEffects"]', settings: '#topbar [data-action="settings"]' },
    'shadows-in-the-forest': { hide: 'header .desktop-audio,#dialog .setting:has(#musicVolume),#dialog .setting:has(#effectsVolume)', settings: '#settings' }
  };

  function tidyLegacy(state) {
    const policy = legacy[state.id];
    if (!policy) return;
    const title = ({fr:'Réglages',sr:'Podešavanja',ja:'設定',es:'Ajustes'})[(doc.documentElement.lang || 'en').split('-')[0]] || 'Settings';
    for (const element of doc.querySelectorAll(policy.hide)) {
      if (element.closest('.ta-audio-controls')) continue;
      if (!element.hasAttribute('data-native-audio-control')) {
        element.setAttribute('data-native-audio-control', '');
        element.setAttribute('aria-hidden', 'true');
        element.hidden = true;
        element.style.setProperty('display', 'none', 'important');
      }
      const heading = element.closest('dialog')?.querySelector('h1,h2');
      if (heading && heading.textContent !== title) heading.textContent = title;
    }
    if (policy.settings) for (const button of doc.querySelectorAll(policy.settings)) {
      button.setAttribute('aria-label', title);
      button.setAttribute('title', title);
      if (!button.querySelector('svg') && button.textContent.trim().length > 2 && button.textContent !== title) button.textContent = title;
    }
  }

  const messages = {
    en: { music: 'Music', effects: 'SFX', musicVolume: 'Music volume', effectsVolume: 'SFX volume', audioVolume: 'Audio volume', off: 'Off', on: 'On', play: 'Play music', pause: 'Turn music off', percent: 'percent' },
    fr: { music: 'Musique', effects: 'Effets', musicVolume: 'Volume de la musique', effectsVolume: 'Volume des effets', audioVolume: 'Volume audio', off: 'Arrêt', on: 'Activée', play: 'Activer la musique', pause: 'Couper la musique', percent: 'pour cent' },
    ja: { music: '音楽', effects: '効果音', musicVolume: '音楽の音量', effectsVolume: '効果音の音量', audioVolume: '音量', off: 'オフ', on: 'オン', play: '音楽を再生', pause: '音楽を止める', percent: 'パーセント' },
    es: { music: 'Música', effects: 'Efectos', musicVolume: 'Volumen de música', effectsVolume: 'Volumen de efectos', audioVolume: 'Volumen de audio', off: 'Apagada', on: 'Activada', play: 'Activar música', pause: 'Apagar música', percent: 'por ciento' },
    sr: { music: 'Muzika', effects: 'Efekti', musicVolume: 'Jačina muzike', effectsVolume: 'Jačina efekata', audioVolume: 'Jačina zvuka', off: 'Isključeno', on: 'Uključeno', play: 'Pusti muziku', pause: 'Isključi muziku', percent: 'procenata' }
  };

  function labels() {
    const language = (doc.documentElement.lang || 'en').toLowerCase().split('-')[0];
    return messages[language] || messages.en;
  }

  function channelEnabled(state, name) {
    const channel = state.config[name], gate = state.config[name + 'Enabled'];
    try {
      if (gate) return !!gate.get() && (channel ? nativeLevel(channel, 0) : state.effectsLevel) > 0;
      if (channel && typeof channel.isEnabled === 'function') return !!channel.isEnabled();
      return (channel ? nativeLevel(channel, 0) : state.effectsLevel) > 0;
    } catch (_) { return false; }
  }

  function level(value, fallback = 1) {
    const number = Number(value);
    return Number.isFinite(number) ? Math.max(0, Math.min(1, number)) : fallback;
  }

  function savedLevel(id) {
    try {
      const value = global.localStorage.getItem('tabletop-audio:' + id + ':effects');
      return value === null ? 1 : level(value);
    } catch (_) { return 1; }
  }

  function nativeLevel(channel, fallback) {
    try { return level(channel.get(), fallback); } catch (_) { return fallback; }
  }

  function masterLevel(kind) {
    if (!active || active.config.effects || active.config[kind + 'Effects'] === false) return 1;
    return active.effectsLevel;
  }

  function isMusic(media) {
    const role = mediaRoles.get(media) || (media.dataset && media.dataset.tabletopAudio);
    if (role) return role === 'music';
    return media.loop || /(?:^|[\/_-])(?:music|bgm|soundtrack)(?:[\/_-]|\.)/i.test(media.currentSrc || media.src || '');
  }

  function applyMedia(media) {
    if (!volumeProperty || !volumeProperty.set || !volumeProperty.get) return;
    trackedMedia.add(media);
    if (!watchedMedia.has(media) && media.addEventListener) {
      watchedMedia.add(media);
      media.addEventListener('ended', () => trackedMedia.delete(media));
      media.addEventListener('pause', () => trackedMedia.delete(media));
    }
    if (!mediaLevels.has(media)) mediaLevels.set(media, volumeProperty.get.call(media));
    const authored = mediaLevels.get(media);
    volumeProperty.set.call(media, authored * (isMusic(media) ? 1 : masterLevel('html')));
  }

  function updateGains() {
    for (const media of trackedMedia) applyMedia(media);
    for (const [context, gain] of contextGains) {
      if (context.state === 'closed') {
        contextGains.delete(context);
        continue;
      }
      const value = masterLevel('synth');
      try {
        if (gain.gain.setTargetAtTime) gain.gain.setTargetAtTime(value, context.currentTime, 0.01);
        else gain.gain.value = value;
      } catch (_) { gain.gain.value = value; }
    }
  }

  if (volumeProperty && volumeProperty.configurable && volumeProperty.get && volumeProperty.set) {
    Object.defineProperty(mediaProto, 'volume', {
      configurable: true,
      enumerable: volumeProperty.enumerable,
      get() {
        return mediaLevels.has(this) ? mediaLevels.get(this) : volumeProperty.get.call(this);
      },
      set(value) {
        volumeProperty.set.call(this, value);
        mediaLevels.set(this, volumeProperty.get.call(this));
        applyMedia(this);
      }
    });
    const originalPlay = mediaProto.play;
    mediaProto.play = function () {
      applyMedia(this);
      return originalPlay.apply(this, arguments);
    };
  }

  function gainFor(context) {
    if (!contextGains.has(context)) {
      const gain = context.createGain();
      gain.gain.value = masterLevel('synth');
      originalConnect.call(gain, context.destination);
      contextGains.set(context, gain);
    }
    return contextGains.get(context);
  }

  if (originalConnect && originalDisconnect) {
    nodeProto.connect = function (destination) {
      if (this.context && destination === this.context.destination && this !== contextGains.get(this.context)) {
        const args = Array.from(arguments);
        args[0] = gainFor(this.context);
        originalConnect.apply(this, args);
        return destination;
      }
      return originalConnect.apply(this, arguments);
    };
    nodeProto.disconnect = function (destination) {
      const args = Array.from(arguments);
      if (this.context && destination === this.context.destination && contextGains.has(this.context)) {
        args[0] = contextGains.get(this.context);
      }
      return originalDisconnect.apply(this, args);
    };
  }

  function create(tag, className, text) {
    const element = doc.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function write(state, channelName, value) {
    const valueLevel = level(value);
    const channel = state.config[channelName];
    const previous = channel ? nativeLevel(channel, 0) : state.effectsLevel;
    if (previous > 0) {
      state.last[channelName] = previous;
      try { global.localStorage.setItem('tabletop-audio:' + state.id + ':last-' + channelName, String(previous)); } catch (_) {}
    }
    if (channel) {
      channel.set(valueLevel);
    } else {
      state.effectsLevel = valueLevel;
      try { global.localStorage.setItem('tabletop-audio:' + state.id + ':effects', String(valueLevel)); } catch (_) {}
    }
    const gate = state.config[channelName + 'Enabled'];
    if (gate) gate.set(valueLevel > 0);
    else if (channel && typeof channel.isEnabled === 'function' && typeof channel.toggle === 'function' && channelEnabled(state, channelName) !== (valueLevel > 0)) channel.toggle();
    updateGains();
    sync(state);
  }

  function pointerValue(event) {
    if (!drag) return;
    const rect = drag.input.isConnected ? drag.input.getBoundingClientRect() : drag.rect;
    const inset = Math.min(9, rect.width / 4);
    const fraction = (event.clientX - rect.left - inset) / Math.max(1, rect.width - inset * 2);
    drag.input.value = String(Math.round(level(fraction) * 100));
    write(drag.state, drag.channelName, Number(drag.input.value) / 100);
  }

  function finishPointer(event) {
    if (!drag || (event && event.pointerId !== drag.pointerId)) return;
    drag = null;
  }

  function addSlider(state, channelName) {
    const label = create('div', 'ta-audio-channel');
    const channel = state.config[channelName];
    const canToggle = true;
    const name = create(canToggle ? 'button' : 'span', 'ta-audio-name' + (canToggle ? ' ta-audio-toggle' : ''));
    const caption = create('span', 'ta-audio-caption');
    const off = create('span', 'ta-audio-off');
    name.append(caption);
    if (canToggle) {
      name.type = 'button';
      name.append(off);
      name.addEventListener('click', () => {
        if (channelEnabled(state, channelName)) write(state, channelName, 0);
        else {
          const current = channel ? nativeLevel(channel, 0) : state.effectsLevel;
          write(state, channelName, current || state.last[channelName] || (channelName === 'music' ? .12 : .5));
        }
      });
    }
    const input = create('input', 'ta-audio-range');
    const output = create('output', 'ta-audio-value');
    input.type = 'range';
    input.min = '0';
    input.max = '100';
    input.step = '1';
    input.addEventListener('input', () => write(state, channelName, Number(input.value) / 100));
    input.addEventListener('pointerdown', event => {
      if (event.button !== 0 || event.isPrimary === false) return;
      event.preventDefault();
      input.focus({ preventScroll: true });
      drag = { state, channelName, input, pointerId: event.pointerId, rect: input.getBoundingClientRect() };
      pointerValue(event);
    });
    label.append(name, input, output);
    state.root.append(label);
    state.sliders[channelName] = { input, output, name, caption, off, canToggle };
  }

  function findHost(config) {
    const selectors = Array.isArray(config.host) ? config.host : [config.host];
    for (const selector of selectors) {
      if (!selector) continue;
      try {
        const host = typeof selector === 'string' ? doc.querySelector(selector) : selector;
        if (host) return host;
      } catch (_) {}
    }
    return null;
  }

  function sync(state) {
    const text = labels();
    state.root.setAttribute('aria-label', text.audioVolume);
    for (const [name, slider] of Object.entries(state.sliders)) {
      const channel = state.config[name];
      const value = channel ? nativeLevel(channel, 1) : state.effectsLevel;
      const percentage = String(Math.round(value * 100));
      if (!drag || drag.input !== slider.input) slider.input.value = percentage;
      slider.input.style.setProperty('--ta-fill', percentage + '%');
      slider.input.setAttribute('aria-valuetext', percentage + ' ' + text.percent);
      slider.input.setAttribute('aria-label', text[name + 'Volume']);
      slider.input.setAttribute('title', text[name + 'Volume']);
      if (slider.caption.textContent !== text[name]) slider.caption.textContent = text[name];
      if (slider.canToggle) {
        const enabled = channelEnabled(state, name);
        const title = text[name] + ': ' + (enabled ? text.on : text.off);
        slider.name.setAttribute('aria-pressed', String(enabled));
        slider.name.setAttribute('aria-label', title);
        slider.name.setAttribute('title', title);
        slider.off.hidden = enabled;
        if (slider.off.textContent !== text.off) slider.off.textContent = text.off;
      }
      if (slider.output.textContent !== percentage + '%') slider.output.textContent = percentage + '%';
    }
  }

  function mount(state) {
    const host = findHost(state.config);
    if (host && state.root.parentElement !== host) host.append(state.root);
    state.root.dataset.theme = (typeof state.config.theme === 'function' ? state.config.theme() : state.config.theme) || 'dark';
    if (host) host.setAttribute('data-tabletop-audio-host', '');
    tidyLegacy(state);
    if (drag && drag.state === state && drag.input.isConnected && doc.activeElement !== drag.input) {
      drag.input.focus({ preventScroll: true });
    }
    sync(state);
  }

  function refresh() {
    refreshQueued = false;
    for (const state of controls.values()) mount(state);
    updateGains();
  }

  function queueRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    global.queueMicrotask(refresh);
  }

  function attach(config) {
    if (!config || !config.id || !config.host) throw new TypeError('TabletopAudio needs a game id and a host.');
    let state = controls.get(config.id);
    if (!state) {
      const last = {};
      for (const name of ['music', 'effects']) {
        try { last[name] = level(global.localStorage.getItem('tabletop-audio:' + config.id + ':last-' + name), 0); } catch (_) {}
      }
      state = { id: config.id, config, last, effectsLevel: savedLevel(config.id), sliders: {}, root: create('div', 'ta-audio-controls') };
      state.root.dataset.gameAudio = config.id;
      state.root.setAttribute('role', 'group');
      controls.set(config.id, state);
      if (config.music) addSlider(state, 'music');
      addSlider(state, 'effects');
    } else {
      state.config = config;
    }
    active = state;
    mount(state);
    updateGains();
    return {
      refresh,
      get(name) { const channel = state.config[name]; return channel ? nativeLevel(channel, 1) : state.effectsLevel; },
      set(name, value) { write(state, name, value); },
      destroy() {
        if (drag && drag.state === state) drag = null;
        state.root.remove();
        controls.delete(state.id);
        if (active === state) active = null;
        updateGains();
      }
    };
  }

  if (doc) {
    doc.addEventListener('pointermove', event => {
      if (!drag || event.pointerId !== drag.pointerId) return;
      event.preventDefault();
      pointerValue(event);
    }, { capture: true, passive: false });
    doc.addEventListener('pointerup', finishPointer, true);
    doc.addEventListener('pointercancel', finishPointer, true);
    const refreshNativeControls = event => {
      if (!event.target.closest?.('.ta-audio-controls')) queueRefresh();
    };
    doc.addEventListener('change', refreshNativeControls, true);
    doc.addEventListener('input', refreshNativeControls, true);
    doc.addEventListener('click', refreshNativeControls, true);
    if (global.MutationObserver) {
      new global.MutationObserver(queueRefresh).observe(doc.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['lang'] });
    }
    if (global.addEventListener) global.addEventListener('blur', () => finishPointer());
  }

  global.TabletopAudio = {
    attach,
    refresh,
    classify(media, role) {
      if (role !== 'music' && role !== 'effects') throw new TypeError('Audio role must be music or effects.');
      mediaRoles.set(media, role);
      applyMedia(media);
    }
  };
})(window);
